<div class="bg-white rounded row mx-0 shadow-sm">
  <div class="col-md-12">
    <div class="portlet light portlet-fit">
      <div class="portlet-title"></div>
      <div class="portlet-body">
        <div class="mt-element-step">
          <div class="row step-line">
            <div class="col-md-4 mt-step-col first" [class.done]="uploadFlag">
              <div class="mt-step-number bg-white">
                <i class="fa fa-upload"></i>
              </div>
              <div class="mt-step-title uppercase font-grey-cascade">
                {{ "upload" | translate }}
              </div>
              <div class="mt-step-content font-grey-cascade">
                {{ "upload_your_file" | translate }}
              </div>
            </div>
            <div class="col-md-4 mt-step-col" [class.done]="countFlag">
              <div class="mt-step-number bg-white">
                <i class="fa-regular fa-square-check"></i>
              </div>
              <div class="mt-step-title uppercase font-grey-cascade">
                {{ "validate" | translate }}
              </div>
              <div class="mt-step-content font-grey-cascade">
                {{ "valid_and_invalid_count" | translate }}
              </div>
            </div>
            <div class="col-md-4 mt-step-col last" [class.done]="completeFlag">
              <div class="mt-step-number bg-white">
                <i class="fa fa-thumbs-up"></i>
              </div>
              <div class="mt-step-title uppercase font-grey-cascade">
                {{ "complete" | translate }}
              </div>
              <div class="mt-step-content font-grey-cascade">
                {{ "final_step" | translate }}
              </div>
            </div>
          </div>

          <div class="row" *ngIf="uploadFlag">
            <div class="portlet box blue col-md-12 col-sm-12">
              <div class="portlet-title bg-primary p-2 rounded">
                <div class="caption text-white">
                  <i class="fa fa-upload"></i>{{ "upload" | translate }}
                </div>
              </div>
              <div class="portlet-body">
                <form class="form form-horizontal">
                  <div class="form-group">
                    <a
                      href="assets/xlsx/Customers.xlsx"
                      download="Customers.csv"
                      class="btn right btn-outline-primary" *ngIf="type == 'customers'"
                      >{{ "export" | translate }}</a
                    >
                    <a
                    href="assets/xlsx/Claims.xlsx"
                    download="Claims.csv"
                    class="btn right btn-outline-primary" *ngIf="type == 'claims'"
                    >{{ "export" | translate }}</a
                  >
                    <div class="file-input-container">
                      <label for="fileInput">{{
                        "CHOOSE_FILE" | translate
                      }}</label>
                      <input
                        type="file"
                        id="fileInput"
                        (change)="fileChange($event)"
                        accept=".xls,.xlsx"
                        class="d-none"
                      />
                      <span *ngIf="file">{{ file.name }}</span>
                      <span *ngIf="!file">{{
                        "NO_FILE_CHOSEN" | translate
                      }}</span>
                    </div>
                  </div>
                  <br /><br />
                  <button
                    type="button"
                    class="btn right btn-outline-primary"
                    value="next"
                    (click)="validate()"
                  >
                    {{ "next" | translate }}
                  </button>
                  <br /><br />
                </form>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="countFlag">
            <div class="portlet box blue col-md-12 col-sm-12 my-2">
              <div class="portlet-body">
                <form class="form form-horizontal">
                  <div class="form-body">
                    <div>
                      <app-base-report
                        [hasCheckboxes]="false"
                        [reportName]="reportName"
                        [defaultColumns]="displayedColumns"
                        [columnsDisplayNames]="displayTableColumns"
                        [data]="validationResponse"
                        [rowsLength]="totalNumberOfRecords"
                        [showTopBar]="false"
                      >
                      </app-base-report>
                    </div>
                    <br /><br />
                    <div class="">
                      <button
                        type="button"
                        class="btn left btn-outline-primary"
                        (click)="backToUpload()"
                        value="next"
                      >
                        {{ "back" | translate }}
                      </button>
                      <button
                        type="button"
                        class="btn right btn-primary"
                        (click)="finish()"
                        [disabled]="isAllRejected()"
                        value="back"
                      >
                        {{ "finish" | translate }}
                      </button>
                    </div>
                  </div>
                  <br /><br />
                </form>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="completeFlag">
            <div class="portlet box blue col-md-12 col-sm-12">
              <div class="portlet-title bg-primary p-2 rounded">
                <div class="caption text-white">
                  <i class="fa fa-upload"></i>{{ "complete" | translate }}
                </div>
              </div>
              <div class="portlet-body">
                <form class="form form-horizontal">
                  <div class="form-group">
                    <p class="font-grey-cascade">
                      <strong>{{'Bulk_processing_completed'|translate}}</strong>
                    </p>
                  </div>
                  <br />
                  <div class="">
                    <button
                      type="button"
                      class="btn right green-sharp btn-primary"
                      (click)="backToUpload()"
                      value="back"
                    >
                      {{ "Back_To_Upload" | translate }}
                    </button>
                  </div>
                  <br /><br />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p *ngIf="errorMsg" class="text-danger">
    {{ errorMsg |translate }}
  </p>
</div>
